import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate, useResolvedPath } from "react-router-dom";

// Hooks
import { useAuthorization } from "@/Common/hooks/Authorization/Authorization";

// Interfaces
import { IUser } from "@/Common/interfaces/user";

type ProtectedRouteProps = {
	actions: "*" | string[];
	children?: ReactNode;
};

const ProtectedRoute = ({ actions, children }: ProtectedRouteProps) => {
	const user = useSelector((state: { user: { user: IUser } }) => state?.user?.user);
	const { pathname } = useResolvedPath(".");

	const { useMultipleAuth } = useAuthorization();

	const authorized = useMultipleAuth(actions, "atLeastOne");
	const isDeniedRoute = pathname === "/access-denied";

	if (user && !authorized && !isDeniedRoute) {
		return <Navigate to="/access-denied" />;
	}

	return user && authorized ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
